module.exports = __webpack_public_path__ + "static/media/eye.8fe96df2.svg";